import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowUpRight, ClipboardList } from 'lucide-react';
import { services, profile } from '../mock';

const Services = () => {
  const [active, setActive] = useState(services[0].id);
  const current = services.find((s) => s.id === active) || services[0];
  const Icon = Icons[current.icon] || Icons.Sparkles;

  return (
    <section id="servicios" className="py-24 lg:py-32 bg-[#E8DDC8] relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-mark" />
              <span className="eyebrow">En qué puedo ayudarte</span>
            </div>
            <h2 className="font-serif text-[40px] lg:text-[58px] leading-[1.02] text-[#2E2A23] tracking-[-0.02em] max-w-[680px]">
              Servicios pensados para acompañarte
              <span className="italic text-[#B8806E]"> en cada etapa.</span>
            </h2>
          </div>
          <p className="max-w-[360px] text-[15px] leading-[1.7] text-[#2E2A23]/75 font-light">
            Cada proceso es único. Elegí la modalidad que más se ajuste a vos:
            presencial en Rosario (Colonia, Uruguay) u online desde donde
            estés.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          {/* Tabs */}
          <div className="lg:col-span-5 flex flex-col gap-3">
            {services.map((s) => {
              const TabIcon = Icons[s.icon] || Icons.Sparkles;
              const isActive = s.id === active;
              return (
                <button
                  key={s.id}
                  onClick={() => setActive(s.id)}
                  className={`group text-left p-6 rounded-2xl border transition-all duration-500 flex items-start gap-5 ${
                    isActive
                      ? 'bg-[#FAF4E8] border-[#B8806E] shadow-[0_20px_50px_-30px_rgba(155,80,56,0.5)]'
                      : 'bg-transparent border-[#CDBE9C] hover:border-[#B8806E]/60 hover:bg-[#FAF4E8]/60'
                  }`}
                >
                  <span
                    className={`shrink-0 w-12 h-12 rounded-full grid place-items-center transition-colors duration-500 ${
                      isActive
                        ? 'bg-[#B8806E] text-[#FAF4E8]'
                        : 'bg-[#E8DDC8] text-[#B8806E] border border-[#CDBE9C]'
                    }`}
                  >
                    <TabIcon size={20} strokeWidth={1.5} />
                  </span>
                  <div className="flex-1">
                    <div className="flex items-baseline justify-between gap-3">
                      <h3 className="font-serif text-[24px] text-[#2E2A23] leading-tight">
                        {s.title}
                      </h3>
                      <ArrowUpRight
                        size={18}
                        strokeWidth={1.5}
                        className={`shrink-0 transition-transform duration-500 ${
                          isActive ? 'text-[#B8806E] rotate-0' : 'text-[#8A7E6E] -rotate-45'
                        }`}
                      />
                    </div>
                    <p className="text-[12px] tracking-[0.18em] uppercase text-[#8A7E6E] mt-1">
                      {s.subtitle}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>

          {/* Active panel */}
          <div className="lg:col-span-7">
            <div className="relative h-full bg-[#FAF4E8] rounded-[24px] overflow-hidden border border-[#DBCEB4]">
              <div className="relative h-[260px] lg:h-[320px] overflow-hidden">
                <img
                  key={current.id}
                  src={current.image}
                  alt={current.title}
                  className={`w-full h-full object-cover img-hover ${
                    current.image.includes('customer-assets.emergentagent') ? 'photo-no-watermark' : ''
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2E2A23]/40 to-transparent" />
                <div className="absolute bottom-5 left-6 flex items-center gap-3 text-[#FAF4E8]">
                  <Icon size={18} strokeWidth={1.6} />
                  <span className="text-[12px] tracking-[0.22em] uppercase">
                    {current.subtitle}
                  </span>
                </div>
              </div>
              <div className="p-8 lg:p-10">
                <h3 className="font-serif text-[32px] lg:text-[40px] text-[#2E2A23] leading-[1.05]">
                  {current.title}
                </h3>
                <p className="mt-5 text-[16px] leading-[1.75] text-[#2E2A23]/80 font-light">
                  {current.description}
                </p>
                <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                  {current.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-[14.5px] text-[#2E2A23]/85">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#B8806E] shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
                <div className="mt-8 flex flex-wrap items-center gap-3">
                  <a
                    href={profile.whatsapp}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-primary"
                  >
                    Quiero saber más
                    <ArrowUpRight size={16} strokeWidth={1.6} />
                  </a>
                  {current.id === 'lactancia' && (
                    <Link to="/pre-consulta-lactancia" className="btn-ghost">
                      <ClipboardList size={16} strokeWidth={1.6} />
                      Llenar pre-consulta
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
